import React from "react";
import { motion } from "framer-motion";
import { SCREEN_ANIMATION } from "../constants/animations";
import { NavigationButtons } from "./NavigationButtons";
import { MainContent } from "./MainContent";
import { UI_STYLES } from "@/styles/uiStyles";
import { AstroPrognosisStatus } from "../types/AstroPrognosisStatus";
import { ZodiacalPrognosisStatus } from "../types/ZodiacalPrognosisStatus";
import { LuckyCardStatus } from "../types/LuckyCardStatus";
import { CardOfTheDayStatus } from "../types/CardOfTheDayStatus";

interface HomeContainerProps {
  navigateToChat: () => void;
  onOpenSettings: () => void;
  cardOfTheDayStatus: CardOfTheDayStatus | null;
  astroPrognosisStatus: AstroPrognosisStatus | null;
  zodiacalPrognosisStatus: ZodiacalPrognosisStatus | null;
  luckyCardStatus: LuckyCardStatus | null;
  navigateToCardOfTheDay: () => void;
  navigateToAstroPrognosis: () => void;
  navigateToZodiacPrognosis: () => void;
  navigateToLuckyCard: () => void;
}

export const HomeContainer: React.FC<HomeContainerProps> = ({
  navigateToChat,
  onOpenSettings,
  cardOfTheDayStatus,
  astroPrognosisStatus,
  zodiacalPrognosisStatus,
  luckyCardStatus,
  navigateToCardOfTheDay,
  navigateToAstroPrognosis,
  navigateToZodiacPrognosis,
  navigateToLuckyCard,
}) => {

  const columnSettings = [
    { gridColumn: "1", gridRow: "2/5" },
    { gridColumn: "2", gridRow: "2/6" },
    { gridColumn: "1", gridRow: "5/9" },
    { gridColumn: "2", gridRow: "6/9" },
  ];

  const gridSettings = {
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "10px 1fr 1fr 1fr 0.5fr 1fr 1fr 1fr",
    gap: "10px",
    width: "100%",
    height: "100%",
    aspectRatio: "6/9",
  };

  return (
    <motion.div
      {...SCREEN_ANIMATION}
      className={`h-full ${UI_STYLES.backgroundGradientTailwind}`}
    >
      <div 
      className={`flex 
      flex-col items-center max-w-xl mx-auto justify-center py-4 pt-8 pb-8 px-4 w-full h-full `}>
        <div className="grid w-full" style={gridSettings}>
          <NavigationButtons
            onNavigateToChat={navigateToChat}
            onOpenSettings={onOpenSettings}
          />

          <MainContent
            cardOfTheDayStatus={cardOfTheDayStatus}
            astroPrognosisStatus={astroPrognosisStatus}
            zodiacalPrognosisStatus={zodiacalPrognosisStatus}
            luckyCardStatus={luckyCardStatus}
            navigateToCardOfTheDay={navigateToCardOfTheDay}
            navigateToAstroPrognosis={navigateToAstroPrognosis}
            navigateToZodiacPrognosis={navigateToZodiacPrognosis}
            navigateToLuckyCard={navigateToLuckyCard}
            gridSettings={columnSettings}
          />
        </div>
      </div>
    </motion.div>
  );
};
